import { render, staticRenderFns } from "./AcceptButton.vue?vue&type=template&id=12dfe232"
import script from "./AcceptButton.vue?vue&type=script&lang=ts"
export * from "./AcceptButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports